import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';

import useAddPage from 'hooks/useAddPage';
const LoangroupAddPage = (props) => {
		const app = useApp();
	const api = useApi();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		branchcode: yup.string().nullable().label($t('branchcode')),
		groupid: yup.string().required().label($t('groupid')),
		groupname: yup.string().required().label($t('groupname')),
		meeting_center: yup.string().required().label($t('meetingCenter')),
		groupstartdate: yup.string().required().label($t('groupstartdate')),
		groupheadid: yup.string().nullable().label($t('groupheadid')),
		groupheadname: yup.string().nullable().label($t('groupheadname')),
		asstgrouphead: yup.string().nullable().label($t('asstgrouphead')),
		dayofcollection: yup.string().nullable().label($t('dayofcollection')),
		empcode: yup.string().nullable().label($t('empcode')),
		sales_empcode: yup.string().nullable().label($t('salesEmpcode')),
		meeting_time: yup.string().nullable().label($t('meetingTime')),
		cgt1_date: yup.string().nullable().label($t('cgt1Date')),
		cgt2_date: yup.string().nullable().label($t('cgt2Date')),
		grt_date: yup.string().nullable().label($t('grtDate')),
		village: yup.string().nullable().label($t('village')),
		panchayat: yup.string().nullable().label($t('panchayat'))
	});
	
	//form default values
	const formDefaultValues = {
		branchcode: '', 
		groupid: '', 
		groupname: '', 
		meeting_center: '', 
		groupstartdate: new Date(), 
		groupheadid: '', 
		groupheadname: '', 
		asstgrouphead: '', 
		dayofcollection: '', 
		empcode: '', 
		sales_empcode: '', 
		meeting_time: new Date(), 
		cgt1_date: new Date(), 
		cgt2_date: new Date(), 
		grt_date: new Date(), 
		village: '', 
		panchayat: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/loangroup`);
		}
	}
	
	//auto fill other inputs on branchcode change
	async function branchcodeAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/loangroup_branchcode_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('groupid', data.value);
		}
	};
	
	//auto fill other inputs on groupheadid change
	async function groupheadidAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/loangroup_groupheadid_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('groupheadname', data.membername);
		}
	};
    async function branchcodeAutoFill(e, formik, index) {
        formik.handleChange(e);
        const val = e.target.value;
        const resp = await api.get(`components_data/loangroup_branchcode_autofill?value=${val}`);
        const data = resp.data[0];
        if(data){
formik.setFieldValue('groupid', data.value);
        }
    };
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="LoangroupAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewLoangroup')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('branchcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/branchcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="branchcode"     optionLabel="label" optionValue="value" value={formik.values.branchcode} onChange={(e)=>branchcodeAutoFill(e, formik)} options={response} label={$t('branchcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.branchcode)}   />
                                                    <ErrorMessage name="branchcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="groupid"  onChange={formik.handleChange}  value={formik.values.groupid}   label={$t('groupid')} type="text" placeholder={$t('enterGroupid')}        className={inputClassName(formik?.errors?.groupid)} />
                                                <ErrorMessage name="groupid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupname')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="groupname"  onChange={formik.handleChange}  value={formik.values.groupname}   label={$t('groupname')} type="text" placeholder={$t('enterGroupname')}        className={inputClassName(formik?.errors?.groupname)} />
                                                <ErrorMessage name="groupname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('meetingCenter')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/meeting_center_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="meeting_center"     optionLabel="label" optionValue="value" value={formik.values.meeting_center} onChange={formik.handleChange} options={response} label={$t('meetingCenter')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.meeting_center)}   />
                                                    <ErrorMessage name="meeting_center" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupstartdate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="groupstartdate" showButtonBar className={inputClassName(formik?.errors?.groupstartdate)} dateFormat="yy-mm-dd" value={formik.values.groupstartdate} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="groupstartdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupheadid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/groupheadid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="groupheadid"     optionLabel="label" optionValue="value" value={formik.values.groupheadid} onChange={(e)=>groupheadidAutoFill(e, formik)} options={response} label={$t('groupheadid')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.groupheadid)}   />
                                                    <ErrorMessage name="groupheadid" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('groupheadname')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="groupheadname"  onChange={formik.handleChange}  value={formik.values.groupheadname}   label={$t('groupheadname')} type="text" placeholder={$t('enterGroupheadname')}        className={inputClassName(formik?.errors?.groupheadname)} />
                                                <ErrorMessage name="groupheadname" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('asstgrouphead')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/groupheadid_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="asstgrouphead"     optionLabel="label" optionValue="value" value={formik.values.asstgrouphead} onChange={formik.handleChange} options={response} label={$t('asstgrouphead')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.asstgrouphead)}   />
                                                    <ErrorMessage name="asstgrouphead" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('dayofcollection')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="dayofcollection"     optionLabel="label" optionValue="value" value={formik.values.dayofcollection} onChange={formik.handleChange} options={app.menus.dayofcollection} label={$t('dayofcollection')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.dayofcollection)}   />
                                                <ErrorMessage name="dayofcollection" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('empcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="empcode"     optionLabel="label" optionValue="value" value={formik.values.empcode} onChange={formik.handleChange} options={response} label={$t('empcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.empcode)}   />
                                                    <ErrorMessage name="empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('salesEmpcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/empcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="sales_empcode"     optionLabel="label" optionValue="value" value={formik.values.sales_empcode} onChange={formik.handleChange} options={response} label={$t('salesEmpcode')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.sales_empcode)}   />
                                                    <ErrorMessage name="sales_empcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('meetingTime')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="meeting_time" value={formik.values.meeting_time} onChange={formik.handleChange} showButtonBar className={inputClassName(formik?.errors?.meeting_time)}     showTime timeOnly     />
                                                <ErrorMessage name="meeting_time" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('cgt1Date')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="cgt1_date" showButtonBar className={inputClassName(formik?.errors?.cgt1_date)} dateFormat="yy-mm-dd" value={formik.values.cgt1_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="cgt1_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('cgt2Date')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="cgt2_date" showButtonBar className={inputClassName(formik?.errors?.cgt2_date)} dateFormat="yy-mm-dd" value={formik.values.cgt2_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="cgt2_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('grtDate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="grt_date" showButtonBar className={inputClassName(formik?.errors?.grt_date)} dateFormat="yy-mm-dd" value={formik.values.grt_date} onChange={formik.handleChange} showIcon        />
                                                <ErrorMessage name="grt_date" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('village')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="village"  onChange={formik.handleChange}  value={formik.values.village}   label={$t('village')} type="text" placeholder={$t('enterVillage')}        className={inputClassName(formik?.errors?.village)} />
                                                <ErrorMessage name="village" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('panchayat')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="panchayat"  onChange={formik.handleChange}  value={formik.values.panchayat}   label={$t('panchayat')} type="text" placeholder={$t('enterPanchayat')}        className={inputClassName(formik?.errors?.panchayat)} />
                                                <ErrorMessage name="panchayat" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
LoangroupAddPage.defaultProps = {
	primaryKey: 'groupid',
	pageName: 'loangroup',
	apiPath: 'loangroup/add',
	routeName: 'loangroupadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default LoangroupAddPage;
